import { SelectOption } from 'types/SelectOption'

export function toArray<TEnum>(obj: TEnum): SelectOption[] {
  return Object.entries(obj).map(([key, value]) => ({
    label: value,
    value: key
  }))
}
